import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Package: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M16.5 9.4 7.55 4.24' }],
    [
      'path',
      {
        d: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z',
      },
    ],
    ['polyline', { points: '3.29 7 12 12 20.71 7' }],
    ['line', { x1: '12', x2: '12', y1: '22', y2: '12' }],
  ],
];

export default Package;
